<template>
  <div class="content">
    <div class="item">
      <div class="title">
        审核详情
      </div>
      <div class="line"></div>
      <div class="item_content">
        <div v-if="infoData.images" class="picBox">
          <div class="imgT">
            上传图：
          </div>
          <viewer class="picBoxs" :images="infoData.images">
            <a
              v-for="(val, key) in infoData.images"
              :key="key"
              href="javascript:;"
            >
              <img class="img-item" :src="val" :images="val">
            </a>
          </viewer>
        </div>
      </div>
      <div class="txtbox">
        <div class="left">
          审核编号：
        </div>
        <div class="right">
          {{ infoData.orderNo }}
        </div>
      </div>
      <div class="txtbox">
        <div class="left">
          昵称：
        </div>
        <div class="right">
          {{ infoData.userName }}
        </div>
      </div>
      <div class="txtbox">
        <div class="left">
          手机号：
        </div>
        <div class="right">
          {{ infoData.cellPhone }}
        </div>
      </div>
      <div class="txtbox">
        <div class="left">
          上传时间：
        </div>
        <div class="right">
          {{ infoData.createTime }}
        </div>
      </div>
      <div class="txtbox" style="align-items: flex-start;">
        <div class="left">
          审核状态：
        </div>
        <div class="right">
          <div>
            <span v-show="infoData.state == 0">
              待审核
            </span>
            <span v-show="infoData.state == 1">
              已到账
            </span>
            <span v-show="infoData.state == 2" style="color:#d7000f">
              审核不通过
            </span>
          </div>
          <div v-show="$route.query.status == 'shenhe'" class="tips">
            Tips:日常垃圾分为可回收、厨余垃圾、有害垃圾、其他垃圾，若判定无误：建议赠予10积分
          </div>
        </div>
      </div>
      <div
        v-show="$route.query.status == 'view' && infoData.environmental"
        class="txtbox"
      >
        <div class="left">
          到账积分：
        </div>
        <div class="right">
          {{ infoData.environmental }}积分
        </div>
      </div>
      <div
        v-show="$route.query.status == 'view' && infoData.handleName"
        class="txtbox"
      >
        <div class="left">
          审核人：
        </div>
        <div class="right">
          {{ infoData.handleName }}
        </div>
      </div>
      <div
        v-show="$route.query.status == 'view' && infoData.handleTime"
        class="txtbox"
      >
        <div class="left">
          审核时间：
        </div>
        <div class="right">
          {{ infoData.handleTime }}
        </div>
      </div>
      <div
        v-show="$route.query.status == 'shenhe'"
        class="txtbox"
        style="align-items: flex-start;"
      >
        <div class="left">
          审核：
        </div>
        <div class="right">
          <a-checkbox-group v-model="values" @change="onChange">
            <a-checkbox value="1">
              审核通过
            </a-checkbox>
            <a-checkbox value="2">
              审核不通过
            </a-checkbox>
          </a-checkbox-group>
          <div v-show="values[0] == 1" style="margin-top:10px;display: block;" :class="number.length > 0 ? '' : 'selectBox'">
            <a-select
              :value="number"
              style="width: 300px"
              placeholder="选择赠予积分"
              @change="handleChange"
            >
              <a-select-option value="2">
                2
              </a-select-option>
              <a-select-option value="10">
                10
              </a-select-option>
              <a-select-option value="20">
                20
              </a-select-option>
              <a-select-option value="30">
                30
              </a-select-option>
              <a-select-option value="50">
                50
              </a-select-option>
              <a-select-option value="50">
                100
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </div>
    <div class="btns">
      <a-button
        v-show="$route.query.status == 'shenhe'"
        @click="back"
      >
        取消
      </a-button>
      <a-button
        v-show="$route.query.status == 'shenhe'"
        style="margin-left:20px"
        type="primary"
        @click="sure"
      >
        确定
      </a-button>
      <a-button
        v-show="$route.query.status == 'view'"
        style="margin-left:20px"
        @click="back"
      >
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      infoData: {},
      values: [],
      number: ''
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.$httpPost(this.$basePath.rewardEnvironmentalDetail, {
        id: this.$route.query.id
      }).then(res => {
        if (res.code === 0) {
          this.infoData = res.result
          this.infoData.images = res.result.paths
            ? res.result.paths.split(',')
            : null
        }
      })
    },
    handleChange (e) {
      this.number = e
    },
    onChange (checkedValues) {
      if (checkedValues[checkedValues.length - 1] == 2) {
        this.number = ''
      }
      this.values = [checkedValues[checkedValues.length - 1]]
    },
    back () {
      this.$router.go(-1)
    },
    sure () {
      if (this.values.length == 0) {
        this.$message.error('请选择审核结果')
        return
      }
      if (this.values[0] == 1 && this.number.length == 0) {
        this.$message.error('请选择赠予积分')
        return
      }
      this.$httpPost(this.$basePath.handleRewardEnvironmental, {
        id: this.$route.query.id,
        environmental: this.number,
        state: this.values[0]
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #ffffff;
  .line {
    width: 100%;
    height: 1px;
    background: #ccc;
    margin-bottom: 30px;
  }
  .item {
    padding: 20px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 15px;
    }
    .item_content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 30px;
      .picBox {
        width: 50%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .picBoxs {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          a {
            margin-right: 20px;
            width: 150px;
            height: 150px;
          }
          img {
            width: 150px;
            height: 150px;
          }
        }
        .imgT {
          font-size: 14px;
          width: 80px;
        }
      }
    }
    .txtbox {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      margin-bottom: 20px;
      .left {
        width: 100px;
      }
      .tips {
        height: 30px;
        line-height: 30px;
        color: #d7000f;
      }
    }
  }
  .btns {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.selectBox{
  /deep/.ant-select-selection__placeholder {
    display: block !important;
  }
}
</style>
